import React, {useRef} from 'react';
import styled from 'styled-components';
import RecentReadItem from './RecentReadItem';
import {useWindowSize} from '../../../hooks/useWindowSize';
import {
    mobileMediaQuery,
    notWebMediaQuery,
    useBreakpoint,
    useIsWeb,
} from '../../../styles';
import ScrollContainer from 'react-indiana-drag-scroll';

const RecentReadView = props => {
    const {width} = useWindowSize();
    const breakpoint = useBreakpoint();
    const isWeb = useIsWeb();
    const scrollContainerRef = useRef(null);
    const screenWidth = Math.min(width, props.maxWidth || 1440);

    if (props.chapters.length === 0) {
        return <EmptyView />;
    }

    let cardWidth;
    let scrollWidth = screenWidth;
    if (['xs', 'sm', 'mobile'].includes(breakpoint)) {
        if (props.chapters.length === 1) {
            cardWidth = width - 3 * 25;
        } else {
            cardWidth = width - 3 * 25 - 16;
        }
    } else if (['md'].includes(breakpoint)) {
        cardWidth = 350;
    } else if (props.maxItems === 3) {
        cardWidth = (screenWidth - 28 - 160) / 3;
        scrollWidth = screenWidth - 80;
    } else {
        cardWidth = (screenWidth - 120 - 24) / 2;
        scrollWidth = screenWidth - 80;
    }

    return (
        <Container maxWidth={props.maxItems === 2 && 1088}>
            <Scroll
                className="scroll-container"
                innerRef={scrollContainerRef}
                vertical={false}
                width={scrollWidth}
            >
                <ItemRow>
                    {!isWeb && (
                        <div>
                            <Spacer />
                        </div>
                    )}
                    {props.chapters.map((chapter, index) => {
                        return (
                            <RecentReadItem
                                chapter={chapter}
                                key={chapter.id.toString()}
                                width={cardWidth}
                                marginRight={
                                    index !== props.chapters.length - 1 ? 16 : 0
                                }
                                useChapterCover={props.useChapterCover}
                            />
                        );
                    })}
                    {!isWeb && (
                        <div>
                            <Spacer />
                        </div>
                    )}
                </ItemRow>
            </Scroll>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    ${props => props.maxWidth && `max-width: ${props.maxWidth}px;`}
`;

const EmptyView = styled.div`
    width: 0px;
    height: 0px;
`;

const Scroll = styled(ScrollContainer)`
    position: relative;
    width: 100%;
    width: ${props => props.width}px;
    height: 120px;
    margin: 0px 40px;

    ${notWebMediaQuery} {
        margin: 0px 0px;
    }
`;

const ItemRow = styled.div`
    flex-direction: row;
    display: flex;
`;

const Spacer = styled.div`
    width: 40px;
    height: 115px;
    ${mobileMediaQuery} {
        width: 25px;
    }
`;

export default RecentReadView;
